import { computed } from 'vue';
import { useRoute } from 'vue-router';
import type { RouteLocationMatched } from 'vue-router';

/**
 * Tries to return the parent route
 * @returns {@code null} if no parent, else the parent {@link RouteLocationMatched}
 */
export const useParentRoute = () => {
  const route = useRoute();

  return computed<RouteLocationMatched | null>((P) => {
    const length = route.matched.length;
    if (length < 2) {
      return null;
    }
    return route.matched[length - 2];
  });
};

export const useParentRoutes = () => {
  const route = useRoute();

  return computed<RouteLocationMatched[]>(() => {
    return route.matched.slice(0, -1);
  });
};
